import { RETIRED_QUESTION_TYPES } from '../config/featureFlags.js'

// s126: a question type that is turned off (EPWORTH_ENABLED=false → 'epworth') is dropped from EVERY catalog this store
// serves — the bundled fallback and the live API catalog — so no screen asks, counts or voice-fills it. The catalog
// itself (and the DB copy) keeps the question: the switch is the app's, not a deletion.
export function withoutRetiredQuestions(specialties, retired = RETIRED_QUESTION_TYPES) {
  if (!Array.isArray(specialties) || !retired.length) return specialties
  return specialties.map((sp) => (!Array.isArray(sp?.focusAreas) ? sp : {
    ...sp,
    focusAreas: sp.focusAreas.map((fa) => {
      if (!fa || !fa.questions || typeof fa.questions !== 'object') return fa
      const questions = {}
      for (const [cat, qs] of Object.entries(fa.questions)) {
        questions[cat] = Array.isArray(qs) ? qs.filter((q) => !retired.includes(q?.type)) : qs
      }
      return { ...fa, questions }
    }),
  }))
}
